import { APP_STORE_URL, PLAY_STORE_URL } from "../../lib/app-store";

export function StoreButtons() {
  return (
    <div className="flex items-center gap-5">
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-btn google-play block transition-all hover:opacity-80"
        aria-label="Google Play"
      >
        <img
          src="/images/google-play.webp"
          alt=""
          width={144}
          height={50}
          loading="lazy"
          decoding="async"
          className="h-[50px] w-[144px] object-contain"
        />
      </a>
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-btn app-store block transition-all hover:opacity-80"
        aria-label="App Store"
      >
        <img
          src="/images/app-store.webp"
          alt=""
          width={144}
          height={50}
          loading="lazy"
          decoding="async"
          className="h-[50px] w-[144px] object-contain"
        />
      </a>
    </div>
  );
}
